import { Seo } from "@/components/Seo";

const LegalShell = ({ title, children }) => (
  <>
    <section className="bg-navy grain relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8">
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold tracking-tighter text-white">{title}</h1>
      </div>
    </section>
    <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 space-y-10">{children}</div>
    </section>
  </>
);

const Block = ({ heading, children }) => (
  <div>
    <h2 className="font-display text-2xl font-semibold text-navy tracking-tight">{heading}</h2>
    <div className="mt-4 text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Mentions() {
  return (
    <LegalShell title="Mentions légales">
      <Seo title="Mentions légales" description="Mentions légales du site umbo-it.fr — Nord VOIP SASu, Lille." path="/mentions-legales" />
      <Block heading="Éditeur du site">
        <p>Le présent site est édité par <strong className="text-navy">Nord VOIP SASU</strong>, société par actions simplifiée unipersonnelle au capital de 500 €, exploitant la marque commerciale <strong className="text-navy">Umbo.</strong></p>
        <ul className="list-none space-y-1">
          <li>SIRET :89200024100018</li>
          <li>Siège social : 679 avenue de la République, 59800 Lille</li>
          <li>Téléphone : 03 20 49 02 04</li>
          <li>Email : contact@umbocyber.fr</li>
        </ul>
      </Block>
      <Block heading="Directeur de la publication">
        <p>Le directeur de la publication est le représentant légal de Nord VOIP, Jérémy VERBEKEN.</p>
      </Block>
      <Block heading="Hébergement">
        <p>Le présent site est hébergé par Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, États-Unis. Téléphone : +1 888 993 5273.</p>
      </Block>
      <Block heading="Propriété intellectuelle">
        <p>L'ensemble des contenus présents sur ce site (textes, visuels, logo, marque Umbo) est protégé par le droit de la propriété intellectuelle. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable de Nord VOIP SASu.</p>
      </Block>
      <Block heading="Responsabilité">
        <p>Nord VOIP SASu s'efforce d'assurer l'exactitude des informations diffusées sur ce site. Les tarifs indiqués sont donnés hors taxes et peuvent évoluer. Ils ne constituent pas une offre contractuelle.</p>
      </Block>
    </LegalShell>
  );
}
